export const tabIds = {
  product: "product",
  benefits: "benefits"
}

export const productFormHeadingText = {
  create: "Para criar um produto, preencha os campos abaixo, fornecendo as informações necessárias.",
  update: "Para editar um produto, edite os campos abaixo, fornecendo as informações necessárias."
}

export const submitionError = {
  create:
    "Erro ao criar produto. Verifique se preencheu todos os dados obrigatórios corretamente e se o limite de caracteres está compatível com o limite estipulado",
  update:
    "Erro ao atualizar o produto. Verifique se preencheu todos os dados obrigatórios corretamente e se o limite de caracteres está compatível com o limite estipulado"
}

export const submitionSuccess = {
  create: "Produto criado com sucesso!",
  update: "Produto atualizado com sucesso!"
}

export const productsBenefitsLimit = 5

export const defaultProductBannerColor = "#002C98"

export const defaultProductBannerColorSecondary = "#6729EA"

export const invalidFileFormat = "Formato de arquivo inválido"
